var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input-number',{model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }